// DS: C02
// A duplicate because Popper doesn't render on SSR
// will be cleaned up once promo is over - T53681
import React from 'react';
import c from 'classnames';
import { useTranslation, Trans } from 'react-i18next';
import { PapiUser, PapiSession } from '@wix/da-papi-types';
import CoreIconSmall from '@wix/da-ds/pkg/Icons/CoreIconSmall';
import { formatDate } from '@wix/da-shared-react/pkg/Timestamp/functions';
import s from './CoreSaleTooltip.scss';

const dateFormat: Intl.DateTimeFormatOptions = {
  month: 'long',
  day: 'numeric',
};

export interface Props {
  currentPromo?: Unpacked<PapiSession['promos']>;
  profileOwner: PapiUser;
  className?: string;
}

export const CoreSaleTooltip: React.FC<Props> = ({
  className,
  currentPromo,
  profileOwner,
}) => {
  const { t, i18n } = useTranslation();
  if (
    !currentPromo ||
    currentPromo?.type !== 'gift' ||
    profileOwner.type !== 'regular'
  ) {
    return null;
  }
  return (
    <div className={c(s['root'], className)}>
      <CoreIconSmall className={s['core-sale-icon']} />
      <div className={s['core-sale-copy']}>
        {/* prettier-ignore */}
        <Trans i18nKey="navigation.subnavigation.coreSaleBanner.giftCore" values={{username:profileOwner.username}} parent="div">
          Give <strong>{profileOwner.username}</strong> the gift of Core Membership.
        </Trans>
        <div>
          <strong>
            {t('navigation.subnavigation.coreSaleBanner.discount', {
              discount: currentPromo.discountValuePercent,
            })}
          </strong>{' '}
          {currentPromo.endDate &&
            t('navigation.subnavigation.coreSaleBanner.expires', {
              date: formatDate(currentPromo.endDate, dateFormat, i18n.language),
            })}
        </div>
      </div>
      <div className={s['arrow']} />
    </div>
  );
};
CoreSaleTooltip.displayName = 'CoreSaleTooltip';

export default CoreSaleTooltip;
